import { Box, Typography, type BoxProps } from '@mui/material';
import { styled } from '@mui/material/styles';

export interface CertificationBadgeProps extends BoxProps {
  label: string;
  issuer?: string;
}

const CertRoot = styled(Box)(({ theme }) => ({
  padding: theme.spacing(0.5, 0.75),
  border: `1px dashed ${theme.palette.divider}`,
  fontSize: '0.65rem',
  letterSpacing: '0.12em',
  textTransform: 'uppercase',
  color: theme.palette.text.secondary,
  cursor: 'default',

  '&:hover': {
    color: theme.palette.primary.main,
    borderColor: theme.palette.primary.main,
  },
}));

export function CertificationBadge({
  label,
  issuer,
  ...props
}: CertificationBadgeProps) {
  return (
    <CertRoot {...props} title={issuer}>
      <Typography variant="caption">{label}</Typography>
    </CertRoot>
  );
}
